export const makeCognitoConfig = ({ userPoolId, userPoolWebClientId, domain, redirectUrl }) => ({
    Auth: {
        region: 'us-east-1',
        userPoolId: userPoolId,
        userPoolWebClientId: userPoolWebClientId,
        //  identityPoolId: 'us-east-1:b92e0500-272f-413a-8469-a24a7c0a73bb',
        oauth: {
            domain: domain,
            scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: redirectUrl,
            redirectSignOut: redirectUrl,
            responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
    },
});
